import name from './name'

const selectSliceData = state => state[name]
const tenant = state => selectSliceData(state).tenant
const tenantTemplate = state => selectSliceData(state).tenantTemplate
const apiIntegration = state => selectSliceData(state).apiIntegration
const msaActive = state => selectSliceData(state).tenant.features?.assessment?.enabled
const helixMigration = state => selectSliceData(state).helixMigration

export {
  tenant,
  tenantTemplate,
  apiIntegration,
  msaActive,
  helixMigration
}
